(function () {
  var preloader = document.getElementById('preloader');
  if (!preloader) return;

  function hidePreloader() {
    var duration = (parseFloat(preloader.dataset.duration) || 1.5) * 1000;
    setTimeout(function () {
      preloader.style.transition = 'opacity 0.8s ease';
      preloader.style.opacity = '0';
      setTimeout(function () { preloader.style.display = 'none'; }, 800);
    }, duration);
  }

  if (document.readyState === 'complete') {
    hidePreloader();
  } else {
    window.addEventListener('load', hidePreloader);
  }
})();
